import React from 'react'
import { useParams } from 'react-router-dom'
import FollowButton from '../Components/FollowButton'
import CollapsingHeader from '../Components/CollapsingHeader'
import { useRail } from '../Components/Layout'
import SortedFeed, { NotFoundMessage, useSortParam } from '../Components/SortedFeed'
import { SourceAvatar } from '../Components/SourceAvatar'
import { useDocumentTitle } from '../Hooks/useDocumentTitle'
import { useFeed } from '../Hooks/useFeed'
import { api } from '../Services/api'
import { useFollow } from '../State/Follow'
import { useResource } from '../State/refData'
import { useOpenEvent } from '../Utils/analytics'

/* /izvor/{slug} (spec 5.6): the source's own headlines on every story it
   covered. Following it doesn't make a feed of it: it only makes its
   headlines win on cards elsewhere. */
export default function SourcePage() {
  const { slug } = useParams()
  const [sort, setSort] = useSortParam()
  const { sources: followed } = useFollow()
  const feed = useFeed(
    `source:${slug}:${sort}:${followed.join(',')}`,
    ({ cursor, refresh }) => api.sourceStories(slug, { sort, cursor, followed, refresh }),
    { eventProps: { chip: sort, sort, source_slug: slug } }
  )
  const info = useResource(`source:${slug}`, () => api.source(slug))
  const source = feed.extra.source || info.data
  useDocumentTitle(source?.name || null)
  useRail({ ad: 'source' })
  useOpenEvent('source_open', { source_slug: slug })
  const missing = feed.status === 'error' && feed.error?.response?.status === 404

  return (
    <>
      <CollapsingHeader
        title={source?.name || ''}
        avatar={source && <SourceAvatar source={source} size={40} />}
        action={
          source && (
            <FollowButton kind="source" item={source} variant="header" entry="source_header" />
          )
        }
        compactAction={
          source && (
            <FollowButton
              kind="source"
              item={source}
              variant="header"
              entry="source_header"
              small
            />
          )
        }
      />
      {missing ? (
        <NotFoundMessage />
      ) : (
        <SortedFeed feed={feed} sort={sort} setSort={setSort} adSurface="source" />
      )}
    </>
  )
}
